import { DynamicScopeTables } from './DynamicScopeTables';
import { FileSearchOutlined } from '@ant-design/icons';
import { InitiativeExportButton } from './InitiativeExportButton';
import { InitiativeSection } from '../general';
import { NoData } from '@ui/NoData';
import React from 'react';

import { COPY_SPECIFIC, MESSAGES_COPY } from '@sonar-software/sonar-ts-constants';
import { useInitiativeScopeCounts, useQueryParams } from '@hooks';

export interface ScopeSectionProps {
	initiativeId: number;
}

export const ScopeSection: React.FC<ScopeSectionProps> = ({ initiativeId }) => {
	const { counts, totalCount } = useInitiativeScopeCounts(initiativeId);

	const { queryParams, updateParams } = useQueryParams({
		defaultParams: {
			filters: '',
			ordering: ''
		}
	});

	return (
		<InitiativeSection
			count={ totalCount }
			headerExtra={ <InitiativeExportButton
				disabled={ !totalCount }
				filters={ queryParams.filters }
				initiativeId={ initiativeId } /> }
			icon={ <FileSearchOutlined /> }
			id='initiative-scope'
			title={ COPY_SPECIFIC.SCOPE }>
			{ !totalCount &&
				<NoData
					description={
						<div className='initiative-scope-table-empty-message'>
							{ MESSAGES_COPY.THIS_INITIATIVE_HAS_NO_SCOPE }
						</div>
					} /> }
			{ Boolean(totalCount) && <DynamicScopeTables
				counts={ counts }
				initiativeId={ initiativeId }
				queryParams={ queryParams }
				updateParams={ updateParams } /> }
		</InitiativeSection>
	);
};
